var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.useImgNotSvg)?_c(_vm.svgComponent,{tag:"component",class:_vm.className}):_c('img',{class:_vm.className,attrs:{"src":("/images/" + _vm.name + ".svg")}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ed2fae7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseIcon.vue
// module id = 918
// module chunks = 0